/** TanStack Query hooks for schedule management. */

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/services/api";
import type { Schedule } from "@/types";

export function useSchedules() {
  return useQuery<{ schedules: Schedule[] }>({
    queryKey: ["schedules"],
    queryFn: () => api.get("/reporting/schedules"),
  });
}

export function useCreateSchedule() {
  const qc = useQueryClient();
  return useMutation<Schedule, Error, Partial<Schedule>>({
    mutationFn: (body) => api.post("/reporting/schedules", body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["schedules"] }),
  });
}

export function useUpdateSchedule() {
  const qc = useQueryClient();
  return useMutation<unknown, Error, { scheduleId: string } & Record<string, unknown>>({
    mutationFn: ({ scheduleId, ...body }) => api.put(`/reporting/schedules/${scheduleId}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["schedules"] }),
  });
}

export function useDeleteSchedule() {
  const qc = useQueryClient();
  return useMutation<unknown, Error, string>({
    mutationFn: (id) => api.del(`/reporting/schedules/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["schedules"] }),
  });
}
